import { useEffect, useMemo } from "react";
import { Toaster } from "../components/ui/toaster";
import { Navbar } from "../components/Navbar";
import { SwapCard } from "../components/SwapCard";
import { useToast } from "../components/ui/use-toast";
import { useParams } from "react-router-dom";
import RightNavbar from "../components/RightNavbar";
import {
  useGetSupportedMintsQuery,
  useGetOrganizationsQuery,
} from "../generated/graphql";

export function ExecuteSwap() {
  const { toast } = useToast();
  const { id } = useParams();

  const [{ data: mintsData, error: mintsError }] = useGetSupportedMintsQuery();

  const mints = mintsData?.getSupportedMints;

  const [{ data: organizationData, error: organizationError }] =
    useGetOrganizationsQuery();
  const organizations = organizationData?.getOrganizations;
  const orgId = id ?? organizations?.[0]?.id ?? "";

  const role = useMemo(() => {
    return organizations?.find((org) => org?.id === orgId)?.permission;
  }, [organizations, orgId]);

  useEffect(() => {
    if (mintsError) {
      toast({
        title: "Error",
        description: mintsError.message,
        variant: "destructive",
      });
    }

    if (organizationError) {
      toast({
        title: "Error",
        description: organizationError.message,
        variant: "destructive",
      });
    }
  }, [toast, mintsError, organizationError]);

  return (
    <div className="flex min-h-screen w-full flex-col">
      <Navbar />

      <div className="flex flex-row">
        <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8">
          <SwapCard mintOptions={mints} role={role} />
        </main>
        <RightNavbar />
      </div>
      <Toaster />
    </div>
  );
}
